import { useSyncExternalStore } from "react";
import { DataTableSource, IconButton } from "@carbon6/c6-frontend-design";
import type { TableRow } from "@carbon6/c6-frontend-design";
import styles from "./ListPagination.module.css";

/** 표와 카드 그리드가 공유하는 c6 source의 현재 페이지를 표시한다. */
export function ListPagination<Row extends TableRow>({ source }: { source: DataTableSource<Row> }) {
  const { page, size, total, loadState } = useSyncExternalStore(
    source.subscribe,
    source.getSnapshot,
  );
  const totalPages = Math.max(1, Math.ceil(total / size));
  const first = total === 0 ? 0 : (page - 1) * size + 1;
  const last = Math.min(page * size, total);
  const loading = loadState === "loading";

  return (
    <nav aria-label="목록 페이지" className={styles.pagination}>
      <span>
        {first}–{last} / {total}개
      </span>
      <div className={styles.actions}>
        <IconButton
          disabled={loading || page <= 1}
          size="sm"
          text="이전 페이지"
          variant="surface"
          onClick={() => void source.goToPage(page - 1)}
        />
        <span aria-live="polite">
          {page} / {totalPages}
        </span>
        <IconButton
          disabled={loading || page >= totalPages}
          size="sm"
          text="다음 페이지"
          variant="surface"
          onClick={() => void source.goToPage(page + 1)}
        />
      </div>
    </nav>
  );
}
